import o from "react";
import { Typography as p } from "./Typography.js";
const t = o.memo(p);
export {
  t as default
};
